var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObogrevatelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE1427;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.27,238.19c-5.34,0-9.67-4.33-9.67-9.67c0-5.34,4.33-9.67,9.67-9.67c5.34,0,9.67,4.33,9.67,9.67 C54.95,233.86,50.62,238.19,45.27,238.19z M50.87,228.52c0-3.09-2.51-5.6-5.6-5.6c-3.09,0-5.6,2.51-5.6,5.6 c0,3.09,2.51,5.6,5.6,5.6C48.37,234.12,50.87,231.61,50.87,228.52z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.05,215.59 33.5,215.59 33.5,211.9 45.27,204.1 57.05,211.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.27,217.58c4.16,0,7.8,2.34,9.85,5.85l1.12-0.74c-2.28-3.91-6.33-6.52-10.97-6.52 c-4.63,0-8.68,2.61-10.97,6.52l1.12,0.74C37.48,219.92,41.12,217.58,45.27,217.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.41,213.14 2.62,200.26 2.62,24.69 7.41,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.41,213.14 12.2,200.26 12.2,24.69 7.41,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.03,46.64 12.2,49.13 12.2,24.69 20.03,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.03,46.64 27.86,49.13 27.86,24.69 20.03,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.03,178.31 12.2,175.82 12.2,200.26 20.03,197.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.03,178.31 27.86,175.82 27.86,200.26 20.03,197.77  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.65,213.14 27.86,200.26 27.86,24.69 32.65,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.65,213.14 37.44,200.26 37.44,24.69 32.65,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.27,46.64 37.44,49.13 37.44,24.69 45.27,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.27,46.64 53.1,49.13 53.1,24.69 45.27,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.27,178.31 37.44,175.82 37.44,200.26 45.27,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.27,178.31 53.1,175.82 53.1,200.26 45.27,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.9,213.14 53.1,200.26 53.1,24.69 57.9,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.9,213.14 62.69,200.26 62.69,24.69 57.9,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.52,46.64 62.69,49.13 62.69,24.69 70.52,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.52,46.64 78.35,49.13 78.35,24.69 70.52,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.52,178.31 62.69,175.82 62.69,200.26 70.52,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.52,178.31 78.35,175.82 78.35,200.26 70.52,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "83.14,213.14 78.35,200.26 78.35,24.69 83.14,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "83.14,213.14 87.93,200.26 87.93,24.69 83.14,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.76,46.64 87.93,49.13 87.93,24.69 95.76,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.76,46.64 103.59,49.13 103.59,24.69 95.76,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.76,178.31 87.93,175.82 87.93,200.26 95.76,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.76,178.31 103.59,175.82 103.59,200.26 95.76,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.38,213.14 103.59,200.26 103.59,24.69 108.38,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "108.38,213.14 113.18,200.26 113.18,24.69 108.38,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.01,46.64 113.18,49.13 113.18,24.69 121.01,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.01,46.64 128.84,49.13 128.84,24.69 121.01,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.01,178.31 113.18,175.82 113.18,200.26 121.01,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.01,178.31 128.84,175.82 128.84,200.26 121.01,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "133.63,213.14 128.84,200.26 128.84,24.69 133.63,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "133.63,213.14 138.42,200.26 138.42,24.69 133.63,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "146.25,46.64 138.42,49.13 138.42,24.69 146.25,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "146.25,46.64 154.08,49.13 154.08,24.69 146.25,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "146.25,178.31 138.42,175.82 138.42,200.26 146.25,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "146.25,178.31 154.08,175.82 154.08,200.26 146.25,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "158.87,213.14 154.08,200.26 154.08,24.69 158.87,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "158.87,213.14 163.66,200.26 163.66,24.69 158.87,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.49,46.64 163.66,49.13 163.66,24.69 171.49,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.49,46.64 179.32,49.13 179.32,24.69 171.49,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.49,178.31 163.66,175.82 163.66,200.26 171.49,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.49,178.31 179.32,175.82 179.32,200.26 171.49,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "184.12,213.14 179.32,200.26 179.32,24.69 184.12,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "184.12,213.14 188.91,200.26 188.91,24.69 184.12,11.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.74,46.64 188.91,49.13 188.91,24.69 196.74,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.74,46.64 204.57,49.13 204.57,24.69 196.74,27.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.74,178.31 188.91,175.82 188.91,200.26 196.74,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "196.74,178.31 204.57,175.82 204.57,200.26 196.74,197.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.89,213.14h-26.27c-0.59,0-1.06-0.48-1.06-1.06V12.87c0-0.59,0.48-1.06,1.06-1.06h26.27 c0.59,0,1.06,0.48,1.06,1.06v199.21C232.96,212.66,232.48,213.14,231.89,213.14z M230.62,39.65c0-1.29-1.05-2.34-2.34-2.34 h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,44.48c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34 H230.62z M230.62,49.31c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,54.14 c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,58.97c0-1.29-1.05-2.34-2.34-2.34h-19.02 c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,148.05c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z  M230.62,152.88c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,157.71 c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,162.54c0-1.29-1.05-2.34-2.34-2.34h-19.02 c-1.29,0-2.34,1.05-2.34,2.34H230.62z M230.62,167.37c0-1.29-1.05-2.34-2.34-2.34h-19.02c-1.29,0-2.34,1.05-2.34,2.34H230.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.23,
    y: 176.44,
    className: "st0",
    width: 3.95,
    height: 29.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.49,238.19c-5.34,0-9.67-4.33-9.67-9.67c0-5.34,4.33-9.67,9.67-9.67c5.34,0,9.67,4.33,9.67,9.67 C181.16,233.86,176.84,238.19,171.49,238.19z M177.09,228.52c0-3.09-2.51-5.6-5.6-5.6c-3.09,0-5.6,2.51-5.6,5.6 c0,3.09,2.51,5.6,5.6,5.6C174.59,234.12,177.09,231.61,177.09,228.52z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "183.27,215.59 159.72,215.59 159.72,211.9 171.49,204.1 183.27,211.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.49,217.58c4.16,0,7.8,2.34,9.85,5.85l1.12-0.74c-2.28-3.91-6.33-6.52-10.97-6.52 c-4.63,0-8.68,2.61-10.97,6.52l1.12,0.74C163.7,219.92,167.34,217.58,171.49,217.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.45,
    y: 176.44,
    className: "st0",
    width: 3.95,
    height: 29.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.63,
    y: 28.78,
    className: "st0",
    width: 8.49,
    height: 48.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "245.12,47.26 245.12,33.76 247.38,33.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "245.12,69.76 245.12,56.26 247.38,56.26  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObogrevatelIcon);
export default __webpack_public_path__ + "static/media/obogrevatel_icon.256889e10a940f3327b4b73ca2643397.svg";
export { ForwardRef as ReactComponent };